export default {
	missing: 'No date',
	olderThan: 'Older than {timePeriod}',
	newerThan: 'Newer than {timePeriod}',
	dueIn: 'Within {timePeriod} ',
	overduePeriod: 'Overdue {timePeriod}',
	overdue: 'All overdue',
	daysExceeded: 'Older',
	daysRemaining: 'Newer',
	due: 'Due date',
	todaysDate: 'Today"s date',
	ontime: 'All due dates on time',
	month: 'a month',
	threeMonths: 'three months',
	halfYear: 'half a year',
	year: 'a year',
}
